import { Page } from 'components/shared';
import { TrialCardList } from './trial-card-list';

export const FeatureTrialsPage = () => {
  return (
    <Page title="Trials">
      <hr />
      <TrialCardList />
    </Page>
  );
};
